import { request } from '@/api/request'

export const getUserSongScoresByDifficulty = async (difficulty: number, page: number = 1, sort: string = 'date', searchTerm = '') => {
  const { data } = await request.get(`/webapi/score/song/me/all?difficulty=${difficulty}&page=${page}&sort=${sort}&term=${searchTerm}`);

  return data.value
}

export const getSongDifficultyWorldRank = async (songId: string, difficulty: number) => {
  const { data } = await request.get(`/webapi/score/song?song_id=${songId}&difficulty=${difficulty}&limit=20`);

  return data.value
}

export const getSongDifficultyFriendRank = async (songId: string, difficulty: number) => {
  const { data } = await request.get(`/webapi/score/song/friend?song_id=${songId}&difficulty=${difficulty}&limit=30`);

  return data.value
}

export const getUserScoreRatings = async () => {
  const { data } = await request.get(`/webapi/score/rating/me`);

  return data.value
}

export const getUserScoreRatingProgressions = async (duration: string) => {
  const { data } = await request.get(`/webapi/score/rating_progression/me?duration=${duration}`);

  return data.value
}

export const getScoreTotalWorldRank = async (difficulty: number) => {
  const { data } = await request.get(`/webapi/score/total_ranking/world?difficulty=${difficulty}`);

  return data.value
}

export const getUserScoreTotalWorldRank = async (difficulty: number) => {
  const { data } = await request.get(`/webapi/score/total_ranking/me?difficulty=${difficulty}`);

  return data.value
}


export const getScoreTotalFriendRank = async (difficulty: number) => {
  const { data } = await request.get(`/webapi/score/total_ranking/friend?difficulty=${difficulty}`);

  return data.value
}